<template>
  <div class="block">
    <!-- <div class="title">$vi18n('$i18n# 作品列表 #i18n$')</div> -->

    <div id="tab">
      <!-- <div class="tab-btn">$vi18n('$i18n# 活跃数据 #i18n$')</div> -->
      <!-- <div
        :class="[tabLabel == 1 ? 'tab-btn active' : 'tab-btn']"
        @click="changeTab(1)"
      >
        $vi18n('$i18n# 活跃数据 #i18n$')
      </div> -->
      <!-- <div class="list-border"></div>
      <div
        :class="[tabLabel == 2 ? 'tab-income active' : 'tab-income']"
        @click="changeTab(2)"
      >
        $vi18n('$i18n# 收入数据 #i18n$')
      </div> -->
    </div>
    <!-- $vi18n('$i18n# 活跃数据 #i18n$') -->
    <div class="work-wrap" v-if="tabLabel == 1">
      <div class="date-box">
        <div class="data-filter">
          <span class="mgr25">{{$vi18n('$i18n# 选择日期 #i18n$')}}</span>
          <el-date-picker
            v-model="tableDate"
            type="daterange"
            align="left"
            :start-placeholder="$vi18n('$i18n# 开始日期 #i18n$')"
            :end-placeholder="$vi18n('$i18n# 结束日期 #i18n$')"
            unlink-panels
            range-separator="~"
            :picker-options="pickerOptions"
            value-format="timestamp"
            @change="DateChange"
          >
          </el-date-picker>
          <el-button
            @click="BtnClicked"
            :class="[brighten ? 'active search_btn' : 'search_btn']"
            type="info"
            >{{$vi18n('$i18n# 查找 #i18n$')}}</el-button
          >
        </div>
        <div class="date-wrap">
          <el-radio-group
            v-model="dayNum"
            style="margin-bottom: 30px"
            @change="changeDate"
          >
            <el-radio-button label="7">{{$vi18n('$i18n# 7天 #i18n$')}}</el-radio-button>
            <el-radio-button label="30">{{$vi18n('$i18n# 30天 #i18n$')}}</el-radio-button>
            <el-radio-button label="90">{{$vi18n('$i18n# 90天 #i18n$')}}</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="sort-wrap">
        <span class="sort-box">
          <span class="title">{{$vi18n('$i18n# 排序 #i18n$')}}：</span>
          <div
            class="sort-content"
            :key="index"
            v-for="(item, index) in sortArr"
            @click="changeSort(index)"
          >
            {{ item.title }}
            <span class="el-icon" v-if="activeSort == index">
              <i class="el-icon-back"> </i>
            </span>
            <span class="el-icon-new" v-else>
              <i class="el-icon-back"></i>
            </span>
            <span class="el-border" v-if="index != sortArr.length - 1"></span>
          </div>
        </span>
        <span class="download-wrap" @click="exportFn">
          <img src="../../assets/images/icon_export.png" />
          <span>{{$vi18n('$i18n# 导出数据 #i18n$')}}</span>
        </span>
      </div>
      <div class="data-table" v-loading="activeLoading">
        <el-table :data="activeData" stripe>
          <el-table-column :label="$vi18n('$i18n# 作品名称 #i18n$')" prop="name" align="center" fixed>
          </el-table-column>
          <el-table-column :label="$vi18n('$i18n# 审核状态 #i18n$')" prop="open_svr" align="center">
          </el-table-column>
          <el-table-column
            :label="$vi18n('$i18n# 浏览次数 #i18n$')"
            prop="nowview_counts"
            align="center"
          >
          </el-table-column>
          <el-table-column
            :label="$vi18n('$i18n# 下载次数 #i18n$')"
            prop="nowdownload_counts"
            align="center"
          >
          </el-table-column>
          <!-- <el-table-column label="$vi18n('$i18n# 下载人数 #i18n$')" prop="count" align="center">
          </el-table-column> -->
          <el-table-column
            :label="$vi18n('$i18n# 游戏次数 #i18n$')"
            prop="nowplay_counts"
            align="center"
          >
          </el-table-column>
          <!-- 
          <el-table-column label="$vi18n('$i18n# 游戏人数 #i18n$')" prop="count" align="center">
          </el-table-column> -->
          <el-table-column
            :label="$vi18n('$i18n# 游戏时长(分钟) #i18n$')"
            prop="nowplay_times"
            align="center"
          >
          </el-table-column>
          <el-table-column
            :label="$vi18n('$i18n# 评论数 #i18n$')"
            prop="nowcomment_counts"
            align="center"
          >
          </el-table-column>
          <!-- <el-table-column
            :label="$vi18n('$i18n# 投块数 #i18n$')"
            prop="nowreward_counts"
            align="center"
          >
          </el-table-column> -->
          <el-table-column
            :label="$vi18n('$i18n# 收藏数 #i18n$')"
            prop="nowcollect_counts"
            align="center"
          >
          </el-table-column>
          <el-table-column :label="$vi18n('$i18n# 发布时间 #i18n$')" prop="create_time" align="center">
          </el-table-column>
          <el-table-column align="center" fixed="right" :label="$vi18n('$i18n# 详情 #i18n$')">
            <template slot-scope="scope">
              <span class="all-look" @click="mapDetailClick(scope.row.id)">
                {{$vi18n('$i18n# 查看详情 #i18n$')}}
              </span>
            </template>
          </el-table-column>
          <!-- $vi18n('$i18n# 无数据的时候 #i18n$') -->
          <template slot="empty">
            <div class="img-no" v-if="showDefault">
              <img
                class="img-no-data"
                src="@/assets/images/img_table_no_data.png"
              />
              <div class="noCart">{{$vi18n('$i18n# 暂无数据 #i18n$')}}</div>
            </div>
          </template>
        </el-table>
      </div>
      <el-pagination
        background
        @current-change="handleActiveChange"
        :current-page="pageInfo.page"
        :page-size="pageInfo.pageSize"
        layout="prev, pager, next,jumper"
        :total="pageInfo.total"
        hide-on-single-page
      >
      </el-pagination>
    </div>
    <!-- $vi18n('$i18n# 收入数据 #i18n$') -->
    <div class="work-wrap" v-else>
      <div class="data-filter">
        <span class="mgr25">{{$vi18n('$i18n# 选择日期 #i18n$')}}</span>
        <el-date-picker
          v-model="incomeDate"
          type="daterange"
          align="left"
          :start-placeholder="$vi18n('$i18n# 开始日期 #i18n$')"
          :end-placeholder="$vi18n('$i18n# 结束日期 #i18n$')"
          unlink-panels
          range-separator="~"
          :picker-options="pickerOptions"
          value-format="timestamp"
          @change="DateChange"
        >
        </el-date-picker>
        <el-button @click="incomeBtnClicked" class="search_btn" type="info">
          {{$vi18n('$i18n# 查找 #i18n$')}}
        </el-button>
        <!-- <span class="download-wrap" @click="exportIn">
          <img src="../../assets/images/icon_export.png" />
          <span>$vi18n('$i18n# 导出数据 #i18n$')</span>
        </span> -->
      </div>
      <div class="sort-wrap">
        <span class="sort-box">
          <span class="title">{{$vi18n('$i18n# 排序 #i18n$')}}：</span>
          <div
            class="sort-content"
            :key="index"
            v-for="(item, index) in sortInArr"
            @click="changeInSort(index)"
          >
            {{ item.title }}
            <span class="el-icon" v-if="incomeSort == index">
              <i class="el-icon-back"> </i>
            </span>
            <span class="el-icon-new" v-else>
              <i class="el-icon-back"> </i>
            </span>
            <span class="el-border" v-if="index != sortInArr.length - 1"></span>
          </div>
        </span>
        <span class="download-wrap" @click="exportFn">
          <img src="../../assets/images/icon_export.png" />
          <span>{{$vi18n('$i18n# 导出数据 #i18n$')}}</span>
        </span>
      </div>
      <!-- <div class="work-list">
        <table class="table-wrap" v-loading="loading">
          <tr class="tr-head">
            <td v-for="(title, index) in tableTitleArr" :key="index">
              <p class="tr-title">
                <span> {{ title.title }}</span>
                <img
                  @click="sortDataType(index)"
                  v-if="title.rank"
                  :class="{ activeSort: tableInfo.sortType == index }"
                  src="@/assets/images/icon_order.png"
                />
              </p>
            </td>
          </tr>
          <tr v-for="table in tableData" :key="table.id">
            <td>{{ table.name }}</td>
            <td>{{ table.today_download }}</td>
            <td>{{ table.yesterday_download }}</td>
            <td>{{ table.yesterday_download }}</td>
            <td>{{ table.yesterday_download }}</td>
            <td>{{ table.total_download }}</td>
            <td>
              {{
                table.yesterday_ad_count == -1 ? '--' : table.yesterday_ad_count
              }}
            </td>
            <td>{{ table.ad_count == -1 ? '--' : table.ad_count }}</td>
            <td>{{ table.time | regroupDate }}</td>
            <td class="btn-detail" @click="mapDetailClick(table.id)">
              $vi18n('$i18n# 查看详情 #i18n$')
            </td>
          </tr>
        </table>
        <div class="img-no" v-if="showDefaultImg">
          <div class="img-no-data">
            <img src="@/assets/images/img_table_no_data.png" />
            <p>$vi18n('$i18n# 您暂时还没有数据呢 #i18n$')~</p>
          </div>
        </div>
      </div> -->
      <div class="data-table">
        <el-table :data="tableData" stripe>
          <el-table-column :label="$vi18n('$i18n# 作品名称 #i18n$')" prop="name" align="center" fixed>
          </el-table-column>
          <el-table-column :label="$vi18n('$i18n# 迷你豆数量 #i18n$')" prop="type" align="center">
          </el-table-column>
          <el-table-column :label="$vi18n('$i18n# 迷你点数量 #i18n$')" prop="count" align="center">
          </el-table-column>
          <el-table-column :label="$vi18n('$i18n# 贡献点数量 #i18n$')" prop="count" align="center">
          </el-table-column>
          <el-table-column :label="$vi18n('$i18n# 广告收入 #i18n$')" align="center">
            <el-table-column :label="$vi18n('$i18n# 触发器广告收入 #i18n$')" prop="count" align="center">
              <template slot="header">
                <el-tooltip placement="top">
                  <span
                    >{{$vi18n('$i18n# 触发器收入 #i18n$')}}
                    <img
                      class="icon-help"
                      src="@/assets/images/icon_help.png"
                    />
                  </span>

                  <p slot="content" style="font-size: 16px; color: #fff">
                    {{$vi18n('$i18n# 在地图作品中，用户通过触发器观看的广告记为内购商店广告，该收入是广告收入的一部分。 #i18n$')}}
                  </p>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="$vi18n('$i18n# 内购商店收入 #i18n$')" prop="count" align="center">
              <template slot="header">
                <el-tooltip placement="top">
                  <span
                    >{{$vi18n('$i18n# 内购商店收入 #i18n$')}}
                    <img
                      class="icon-help"
                      src="@/assets/images/icon_help.png"
                    />
                  </span>

                  <p slot="content" style="font-size: 16px; color: #fff">
                    {{$vi18n('$i18n# 在地图作品中，用户通过观看开发者商店内商品的广告记为内购商店广告，该收入是广告收入的一部分。 #i18n$')}}
                  </p>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column :label="$vi18n('$i18n# 通行证收入 #i18n$')" prop="count" align="center">
              <template slot="header">
                <el-tooltip placement="top">
                  <span
                    >{{$vi18n('$i18n# 通行证收入 #i18n$')}}
                    <img
                      class="icon-help"
                      src="@/assets/images/icon_help.png"
                    />
                  </span>

                  <p slot="content" style="font-size: 16px; color: #fff">
                    {{$vi18n('$i18n# 在地图作品中,用户通过观看畅玩通行证的广告记为通行证广告,该收入是广告收入的一部分。 #i18n$')}}
                  </p>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column :label="$vi18n('$i18n# 其他广告收入 #i18n$')" prop="count" align="center">
            </el-table-column>
            <el-table-column :label="$vi18n('$i18n# 合计 #i18n$')" prop="count" align="center">
            </el-table-column>
          </el-table-column>

          <el-table-column :label="$vi18n('$i18n# 发布时间 #i18n$')" prop="count" align="center">
          </el-table-column>
          <el-table-column align="center">
            <template slot="header"><span>{{$vi18n('$i18n# 详情 #i18n$')}}</span> </template>
            <template slot-scope="scope">
              <span class="all-look" @click="mapDetailClick(scope.row.id)">
                {{$vi18n('$i18n# 查看详情 #i18n$')}}
              </span>
            </template>
          </el-table-column>
          <!-- $vi18n('$i18n# 无数据的时候 #i18n$') -->
          <template slot="empty">
            <div class="img-no" v-if="showDefaultImg">
              <img
                class="img-no-data"
                src="@/assets/images/img_table_no_data.png"
              />
              <div class="noCart">{{$vi18n('$i18n# 暂无数据 #i18n$')}}</div>
            </div>
          </template>
        </el-table>
      </div>
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="tableInfo.page"
        :page-size="tableInfo.pageSize"
        layout="prev, pager, next,jumper"
        :total="tableInfo.total"
        hide-on-single-page
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  getMapList,
  downloadData,
  getActiveData,
  getMotivate,
} from '@/api/charts';
import { $vi18n } from '@/utils/i18n.js';
const ONE_WEEK_TIME = 1000 * 60 * 60 * 24 * 7;
const ONE_DAY_TIME = 24 * 60 * 60 * 1000 - 1;
const ONE_DAY = 24 * 60 * 60 * 1000;
export default {
  data() {
    return {
      loading: false,
      showDefaultImg: false,
      showDefault: false,
      activeLoading: false,
      tabLabel: 1,
      singelData: {},
      productLoading: false,
      startTime: '',
      endTime: '',
      tableDate: [],
      incomeDate: [],
      activeSort: 0,
      range: 2,
      incomeSort: 0,
      dayNum: 7,
      //  showDefaultImg:true,
      tableInfo: {
        page: 1,
        pageSize: 10,
        total: 0,
        sortType: 1,
      },
      pageInfo: {
        page: 1,
        pageSize: 10,
        total: 0,
        sortType: 4,
      },
      brighten: false,
      sortArr: [
        { title: $vi18n('$i18n# 发布时间 #i18n$') },
        { title: $vi18n('$i18n# 作品下载总次数 #i18n$') },
        // { title: '$vi18n('$i18n# 游戏总人数 #i18n$') },
        { title: $vi18n('$i18n# 游戏总时长 #i18n$') },
        { title: $vi18n('$i18n# 评论数 #i18n$') },
      ],
      sortInArr: [
        { title: $vi18n('$i18n# 发布时间 #i18n$') },
        { title: $vi18n('$i18n# 迷你豆数量 #i18n$') },
        { title: $vi18n('$i18n# 迷你点数量 #i18n$') },
        { title: $vi18n('$i18n# 贡献点数量 #i18n$') },
        { title: $vi18n('$i18n# 广告收入 #i18n$') },
      ],
      tableData: [],
      activeData: [],
      tableTitleArr: [
        { title: $vi18n('$i18n# 作品名称 #i18n$'), rank: false },
        { title: $vi18n('$i18n# 迷你豆数量 #i18n$'), rank: true },
        { title: $vi18n('$i18n# 迷你点数量 #i18n$'), rank: true },
        { title: $vi18n('$i18n# 贡献点数量 #i18n$'), rank: true },
        { title: $vi18n('$i18n# 广告收入 #i18n$'), rank: true },
        { title: $vi18n('$i18n# 触发器广告收入 #i18n$'), rank: false },
        { title: $vi18n('$i18n# 内购商店收入 #i18n$'), rank: false },
        { title: $vi18n('$i18n# 通行证收入 #i18n$'), rank: false },
        { title: $vi18n('$i18n# 发布时间 #i18n$'), rank: true },
        // { title: '$vi18n('$i18n# 今日下载 #i18n$')($vi18n('$i18n# 预估 #i18n$'))', rank: true },
        // { title: '$vi18n('$i18n# 昨日下载 #i18n$')', rank: true },
        // { title: '$vi18n('$i18n# 总下载 #i18n$')', rank: true },
        // { title: '$vi18n('$i18n# 昨日广告展示 #i18n$')', rank: true },
        // { title: '$vi18n('$i18n# 总广告展示 #i18n$')', rank: true },
        // { title: '$vi18n('$i18n# 上传日期 #i18n$')', rank: true },

        { title: $vi18n('$i18n# 详情 #i18n$'), rank: false },
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: $vi18n('$i18n# 最近一周 #i18n$'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: $vi18n('$i18n# 最近一个月 #i18n$'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: $vi18n('$i18n# 最近三个月 #i18n$'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
    };
  },
  watch: {
    'tableInfo.sortType'() {},
    'pageInfo.sortType'() {
      this.fetchActiveData();
    },
    'tableInfo.page'() {},
    tableData(val) {
      this.showDefaultImg = !(val && val.length);
    },
    activeData(val) {
      this.showDefault = !(val && val.length);
    },
  },
  filters: {
    regroupDate(timestamp) {
      let time = new Date(timestamp * 1000);
      let year = time.getFullYear();
      const month = (time.getMonth() + 1).toString().padStart(2, '0');
      const date = time.getDate().toString().padStart(2, '0');
      return year + '-' + month + '-' + date;
    },
  },
  mounted() {
    // this.getMotivateData();
    this.init();
    if (this.activeData.length == 0) {
      this.showDefault = true;
    } else {
      this.showDefault = false;
    }
    if (this.tableData.length == 0) {
      this.showDefaultImg = true;
    } else {
      this.showDefaultImg = false;
    }
  },
  created() {
    const currTime = new Date(new Date(new Date()).toDateString()).getTime();
    this.tableDate = [currTime - ONE_WEEK_TIME, currTime - ONE_DAY]; //$vi18n('$i18n# 活跃数据时间 #i18n$')
    this.incomeDate = [currTime - ONE_WEEK_TIME, currTime - ONE_DAY];
  },
  methods: {
    sortDataType(index) {
      this.tableInfo.sortType = index;
      this.rankClick(index);
    },
    //$vi18n('$i18n# 获取全地图激励数据 #i18n$')
    async getMotivateData() {
      const time = parseInt(new Date().getTime() / 1000);
      let data = {
        time: time,
        range: this.range,
      };
      const res = await getMotivate(data);
      if (res.data.ret === 0) {
        this.singelData = res.data.msg.single;
      }
    },
    regroupFilDate(timestamp) {
      let time = new Date(timestamp * 1000);
      let year = time.getFullYear();
      const month = (time.getMonth() + 1).toString().padStart(2, '0');
      const date = time.getDate().toString().padStart(2, '0');
      return year + '-' + month + '-' + date;
    },
    changeDate() {
      const nowTime = new Date(new Date(new Date()).toDateString()).getTime();
      //$vi18n('$i18n# 判断选择时间是 #i18n$')7$vi18n('$i18n# 天 #i18n$')/30$vi18n('$i18n# 天 #i18n$')/90$vi18n('$i18n# 天 #i18n$')
      this.endTime =
        new Date(new Date(new Date()).toDateString()).getTime() - 1;
      this.tableDate[1] = this.endTime - ONE_DAY_TIME;
      if (this.dayNum == 7) {
        this.startTime = nowTime - 7 * 24 * 60 * 60 * 1000;
        this.range = 2;
      } else if (this.dayNum == 30) {
        this.startTime = nowTime - 30 * 24 * 60 * 60 * 1000;
        this.range = 3;
      } else {
        this.startTime = nowTime - 90 * 24 * 60 * 60 * 1000;
        this.range = 4;
      }
      this.tableDate[0] = this.startTime;
      // this.getMotivateData();
      this.fetchActiveData();
    },
    async getNActiveData() {
      this.activeLoading = true;
      let data = {
        sort_type: this.pageInfo.sortType,
        page: this.pageInfo.page,
        page_size: this.tableInfo.pageSize,
        start_time: parseInt(this.startTime / 1000, 10),
        end_time: parseInt(this.endTime / 1000, 10),
      };
      try {
        const res = await getActiveData(data);
        if (res.data.list.length) {
          this.activeData = res.data.list.map(item => {
            if (
              item.open_svr === 0 ||
              item.open_svr === 9 ||
              item.open_svr === 1
            ) {
              item.open_svr = $vi18n('$i18n# 审核中 #i18n$');
            } else if (item.open_svr === 10 || item.open_svr === 13) {
              item.open_svr = $vi18n('$i18n# 审核成功 #i18n$');
            } else if (
              item.open_svr === 2 ||
              item.open_svr === 3 ||
              item.open_svr === 7 ||
              item.open_svr === 8
            ) {
              item.open_svr = $vi18n('$i18n# 隐藏 #i18n$');
            } else if (item.open_svr === 4 || item.open_svr === 14) {
              item.open_svr = $vi18n('$i18n# 封禁 #i18n$');
            }
            item.nowplay_times = (item.nowplay_times / 60).toFixed(2);
            item.create_time = this.regroupFilDate(item.create_time);
            return item;
          });
        }

        this.pageInfo.total = res.data.total_count;
        // this.activeData = [];
        this.activeLoading = false;
      } catch (error) {
        console.log(error);
        this.activeLoading = false;
      }
    },
    BtnClicked() {
      //$vi18n('$i18n# 判断 #i18n$')tableDate$vi18n('$i18n# 是否为空 #i18n$')
      if (this.tableDate) {
        this.range = 4;
        // this.getMotivateData();
        this.brighten = true;
        this.fetchActiveData();

        //this.
      }
    },
    incomeBtnClicked() {
      this.fetchMapList();
    },
    // sortDatactive(index) {
    //   this.pageInfo.sortType = index;
    // },
    changeTab(index) {
      this.tabLabel = index;
    },
    changeSort(index) {
      this.activeSort = index;
      switch (index) {
        case 0:
          this.pageInfo.sortType = 4;
          break;
        case 1:
          this.pageInfo.sortType = 2;
          break;
        case 2:
          this.pageInfo.sortType = 10;
          break;
        case 3:
          this.pageInfo.sortType = 11;
          break;
        default:
          break;
      }
    },
    changeInSort(index) {
      this.incomeSort = index;
    },
    DateChange() {},
    //$vi18n('$i18n# 查看地图详情点击埋点 #i18n$')
    mapDetailClick(tid) {
      this.$log('map_details_check_click', 85415, { v7: 1 });
      this.$router.push({ path: '/charts/detail', query: { id: tid } });
    },
    //$vi18n('$i18n# 排序按钮点击埋点 #i18n$')
    rankClick(index) {
      this.$log('rank_click', 85414, { v7: 1, v8: index });
    },
    exportFn() {
      this.ActiveExport();
    },
    // exportIn() {
    //   this.fetchExport();
    // },
    //$vi18n('$i18n# 导出收入数据 #i18n$')
    // async fetchExport() {
    //   let data = {
    //     start_time: parseInt(this.incomeDate[0] / 1000, 10),
    //     end_time: parseInt((this.incomeDate[1] + ONE_DAY_TIME) / 1000, 10)
    //   };
    //   try {
    //     const res = await downloadData(data);
    //     this.downloadFile(res.data.url);
    //     this.$message.success('$vi18n('$i18n# 下载成功 #i18n$')');
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    //$vi18n('$i18n# 导出活跃数据 #i18n$')
    async ActiveExport() {
      let data = {
        start_time: parseInt(this.tableDate[0] / 1000, 10),
        end_time: parseInt((this.tableDate[1] + ONE_DAY_TIME) / 1000, 10),
      };
      try {
        const res = await downloadData(data);
        this.downloadFile(res.data.url);
        this.$message.success($vi18n('$i18n# 下载成功 #i18n$'));
      } catch (error) {
        console.log(error);
      }
    },
    //$vi18n('$i18n# 下载数据 #i18n$')
    downloadFile(url) {
      let a = document.createElement('a');
      a.href = url;
      a.download = url.split('/').pop();
      a.click();
    },
    init() {
      //$vi18n('$i18n# 初始化数据 #i18n$')
      //$vi18n('$i18n# 获取活跃数据 #i18n$')
      this.fetchActiveData();
      if (this.tableTotal) {
        document.getElementsByClassName(
          'el-pagination__jump',
        )[0].childNodes[0].nodeValue = $vi18n('$i18n# 跳至 #i18n$');
      }
    },
    // $vi18n('$i18n# 地图列表 #i18n$')-$vi18n('$i18n# 收入数据 #i18n$')
    async fetchMapList() {
      this.loading = true;
      let data = {
        sort_type: this.tableInfo.sortType,
        page: this.tableInfo.page,
        page_size: this.tableInfo.pageSize,
        start_time: parseInt(this.tableDate[0] / 1000, 10),
        end_time: parseInt((this.tableDate[1] + ONE_DAY_TIME) / 1000, 10),
      };
      try {
        const res = await getMapList(data);
        this.tableData = res.data.list;
        this.tableInfo.total = res.data.total_count;
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    //$vi18n('$i18n# 作品列表 #i18n$')-$vi18n('$i18n# 活跃数据 #i18n$')
    async fetchActiveData() {
      this.activeLoading = true;
      let data = {
        sort_type: this.pageInfo.sortType,
        page: this.pageInfo.page,
        page_size: this.tableInfo.pageSize,
        start_time: parseInt(this.tableDate[0] / 1000, 10),
        end_time: parseInt((this.tableDate[1] + ONE_DAY_TIME) / 1000, 10),
      };
      try {
        const res = await getActiveData(data);
        if (res.data.list.length) {
          this.activeData = res.data.list.map(item => {
            if (
              item.open_svr === 0 ||
              item.open_svr === 9 ||
              item.open_svr === 1
            ) {
              item.open_svr = $vi18n('$i18n# 审核中 #i18n$');
            } else if (item.open_svr === 10 || item.open_svr === 13) {
              item.open_svr = $vi18n('$i18n# 审核成功 #i18n$');
            } else if (
              item.open_svr === 2 ||
              item.open_svr === 3 ||
              item.open_svr === 7 ||
              item.open_svr === 8
            ) {
              item.open_svr = $vi18n('$i18n# 隐藏 #i18n$');
            } else if (item.open_svr === 4 || item.open_svr === 14) {
              item.open_svr = $vi18n('$i18n# 封禁 #i18n$');
            } else if (item.open_svr === 17) {
              item.open_svr = $vi18n('$i18n# 上传成功 #i18n$');
            }
            if (
              Object.prototype.hasOwnProperty.call(this.singelData, item.id)
            ) {
              let obj = this.singelData[item.id];
              // item.nowcollect_counts =
              //   (obj.collect | 0) + item.nowcollect_counts;
              item.nowdownload_counts =
                (obj.download | 0) + item.nowdownload_counts;
              item.nowplay_counts = (obj.play_count | 0) + item.nowplay_counts;
              item.nowplay_times = (obj.play_time | 0) + item.nowplay_times;
              item.nowview_counts = (obj.browse | 0) + item.nowview_counts;
            }
            item.create_time = this.regroupFilDate(item.create_time);
            item.nowplay_times = (item.nowplay_times / 60).toFixed(2);
            //$vi18n('$i18n# 添加激励数据 #i18n$')
            return item;
          });
        }

        this.pageInfo.total = res.data.total_count;
        // this.activeData = [];
        this.activeLoading = false;
        this.brighten = false;
      } catch (error) {
        console.log(error);
        this.activeLoading = false;
      }
    },
    handleActiveChange(val) {
      this.pageInfo.page = val;
      this.fetchActiveData();
    },
    handleCurrentChange(val) {
      this.tableInfo.page = val;
      // this.fetchMapList();
    },
    // cellStyle(column) {
    //   let cellStyle;
    //   if (column.columnIndex === 10) {
    //     cellStyle = 'padding:0;background:red';
    //   }
    //   return cellStyle;
    // }
  },
};
</script>

<style lang="scss" scoped>
$--color-primary: #fd9b21;
.block {
  .title {
    font-size: 20px;
    color: #262626;
    margin-top: -5px;
  }
  // .work-wrap {
  //   margin-left: 17px;
  // }
  .date-box {
    display: flex;
    .date-wrap {
      padding-top: 10px;
      margin-left: 15px;
    }
  }
  .data-filter {
    margin-top: 10px;
    margin-bottom: 10px;
    .mgr25 {
      margin-right: 25px;
    }
    .search_btn {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-left: 0;
      color: #595959;
      border-right: 1px solid #d9d9d9;
      border-top: 1px solid #d9d9d9;
      border-bottom: 1px solid #d9d9d9;
      background-color: #f4f4f5;
    }
    .active.search_btn {
      background: #fd9b21;
    }
  }
  .sort-wrap {
    display: flex;
    .title {
      font-size: 14px;
      margin-top: 0;
    }
    .el-icon {
      .el-icon-back {
        transform: rotate(-90deg);
      }
    }
    .el-icon-new {
      opacity: 0;
    }
    .sort-content {
      margin-right: 5px;
      cursor: pointer;
      .el-border {
        border-right: 2px solid #d8d8d8;
        margin-right: 4px;
      }
    }
    .sort-box {
      display: flex;
      width: 92%;
    }
    .download-wrap {
      //float: right;
      //display: block;
      //margin-right: 150px;
      border-radius: 4px;
      font-size: 11px;
      //background-color: #595959;
      // font-weight: 600;
      //margin-top: 13px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      cursor: pointer;
      color: #2b6ddf;
      img {
        margin-right: 8px;
      }
    }
  }
  .data-table {
    margin-top: 16px;
    border: 1px solid #d9d9d9;
    overflow: hidden;
    border-radius: 3px;
    ::v-deep .el-table tr:last-child td {
      border-bottom: none;
    }
    ::v-deep .el-table::before {
      background: transparent;
    }
    ::v-deep .el-table th {
      background: #fafafa;
      line-height: 29px;
    }
    ::v-deep .el-table td {
      line-height: 29px;
      padding: 7px 0 6px;
    }
    ::v-deep.el-table .cell {
      padding: 0 5px;
    }
    .img-no {
      margin: 20px auto 10px auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .img-no-data-word {
        margin: 10px auto;
      }
    }
    ::v-deep .el-table__empty-text {
      line-height: 30px;
      margin-bottom: 15px;
      margin-top: 15px;
    }
    .all-look {
      color: #2b6ddf;
      // text-decoration: underline;

      display: flex;
      cursor: pointer;
      justify-content: center;
    }
    img.icon-help {
      height: 10px;
      width: 10px;
    }
  }
  #tab {
    //margin: 10px auto 18px 0;
    margin: 10px auto 5px 0;
    font-size: 16px;
    // margin-left: 17px;
    display: flex;
    .tab-btn {
      //margin-right: 20px;
      padding-bottom: 10px;
      font-size: 24px;
      //cursor: pointer;
    }
    .tab-btn.active {
      border-bottom: 3px solid #fd9b21;
    }
    .tab-income {
      padding-bottom: 10px;
      cursor: pointer;
    }
    .tab-income.active {
      border-bottom: 3px solid #fd9b21;
    }
    .list-border {
      border-right: 3px solid #dcdcdc;
      margin: 2px 15px 7px 15px;
    }
  }
}
.work-list {
  margin-top: 20px;
  // margin-left: 20px;
  border: 1px solid #d9d9d9;
  .btn-detail {
    color: #2b6ddf;
    cursor: pointer;
  }
}
.el-pagination {
  text-align: center;
  margin-top: 19px;
}

::v-deep {
  .el-pagination.is-background .el-pager li,
  .el-pagination.is-background button {
    width: 32px;
    height: 32px;
    line-height: 32px;
  }
  .el-pagination.is-background .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
  .el-pagination.is-background .el-pager li:not(.disabled) {
    background-color: #fff;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    color: $--color-primary;
    border: 1px solid #ffc973;
    background: #fffaed;
    border-radius: 4px;
  }
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .btn-next {
    background-color: #fff;

    border-radius: 4px;
    border: 1px solid #d9d9d9;
  }
}
.table-wrap {
  width: 100%;
  .tr-title {
    display: flex;
    align-items: center;
    img {
      margin-left: 3px;
      cursor: pointer;
      width: 15px;
      height: 14px;
      margin-top: -1px;
    }
    .activeSort {
      cursor: text;
    }
  }
  .btn-detail {
    color: #2b6ddf;
    cursor: pointer;
  }
}

tr:nth-child(even) {
  background: #fafafa;
}
.tr-head {
  background: #fafafa;
  border-bottom: 1px solid #d9d9d9;
}
td {
  padding: 10px;
  text-align: left;
  max-width: 225px;
  word-wrap: break-word; //$vi18n('$i18n# 文本换行 #i18n$')
  vertical-align: middle;
}
.img-no {
  margin: 20px auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .img-no-data-word {
    margin: 10px auto;
  }
}
</style>
